export default function MuiSwitcht(theme: any) {
  return {
    MuiSwitch: {
      variants: [
        {
          props: { variant: "outlined" },
          style: {},
        },
      ],
      styleOverrides: {
        root: {
          width: "40px",
          height: "24px",
          marginLeft: theme.spacing(2),
          padding: "0",
          color: theme.palette.grey[0],
          "& .MuiSwitch-track": {
            width: "40px",
            height: "24px",
            borderRadius: theme.shape.borderRadius * 6,
            backgroundColor: theme.palette.grey[600],
            opacity: 1,
          },
          "& .MuiButtonBase-root": {
            padding: "0",
            marginTop: theme.spacing(1.3),
          },
          "& .MuiSwitch-thumb": {
            width: "16px",
            height: "16px",
            color: "white",
          },
          "& .MuiSwitch-switchBase": {
            padding: theme.spacing(0.5),
            marginTop: "0",
          },
          "& .MuiSwitch-switchBase.Mui-checked": {
            transform: "translateX(16px)",
          },
          "& .MuiSwitch-switchBase.Mui-checked+.MuiSwitch-track": {
            backgroundColor: theme.palette.primary.light,
            opacity: 1,
          },
        },
      },
    },
  };
}
